import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import moment from "moment-timezone";
import { apiMongo } from "../api/apiData";
import { formatCurrency } from "../utilities/formatCurrency";
import "moment/locale/pl";
moment.locale("pl");

type CertificateData = {
  certificateNumbers: number[];
  buyerName?: string;
  total_price: number;
  paidAt: string;
  creditBalance: number;
};

const padNumber = (n: number) => n.toString().padStart(5, "0");

export const CertificatePage = () => {
  const { orderId } = useParams();
  const [certificate, setCertificate] = useState<CertificateData | null>(
    null
  );
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const response = await apiMongo.get(
          `${process.env.REACT_APP_MONGO_URL}/game/certificate/${orderId}`
        );
        setCertificate(response.data);
      } catch (error) {
        setNotFound(true);
      }
    };

    if (orderId) {
      fetchCertificate();
    }
  }, [orderId]);

  if (notFound) {
    return (
      <section className="certificate-page">
        <p className="subtitle">
          Nie znaleziono certyfikatu — sprawdź czy płatność została już
          potwierdzona.
        </p>
        <Link to="/" className="button is-primary">
          Wróć do strony głównej
        </Link>
      </section>
    );
  }

  if (!certificate) {
    return (
      <section className="certificate-page">
        <p className="subtitle">Ładowanie certyfikatu...</p>
      </section>
    );
  }

  const date = moment(certificate.paidAt)
    .tz("Europe/Warsaw")
    .locale("pl")
    .format("D MMMM YYYY");

  return (
    <section className="certificate-page">
      <div className="certificate-frame">
        <div className="certificate-card">
          <div className="certificate-paws" aria-hidden="true">
            🐾 🐾 🐾
          </div>

          <div className="certificate-seal">
            <span>🐾</span>
          </div>

          <p className="certificate-eyebrow font-antonio">MapGame</p>
          <h1 className="certificate-title font-antonio">
            Certyfikat wsparcia
          </h1>
          <p className="certificate-subtitle">
            schroniska dla zwierząt bezdomnych
          </p>

          <div className="certificate-divider" />

          <p className="certificate-body">
            Niniejszym zaświadcza się, że
          </p>
          <p className="certificate-name font-antonio">
            {certificate.buyerName || "Wspaniały Człowiek"}
          </p>
          <p className="certificate-body">
            wsparł/a nasze schronisko kwotą
          </p>
          <p className="certificate-amount font-antonio">
            {formatCurrency(certificate.total_price)}
          </p>

          <div className="certificate-divider" />

          <div className="certificate-footer">
            <div>
              <p className="certificate-label">Numer certyfikatu</p>
              <p className="certificate-value">
                {certificate.certificateNumbers.length > 0
                  ? certificate.certificateNumbers
                      .map((n) => `#${padNumber(n)}`)
                      .join(", ")
                  : "wpis pokryty wcześniejszym certyfikatem"}
              </p>
            </div>
            <div>
              <p className="certificate-label">Data</p>
              <p className="certificate-value">{date}</p>
            </div>
          </div>

          {certificate.creditBalance > 0 && (
            <p className="certificate-credit-balance">
              Twój certyfikat pokrywa jeszcze{" "}
              <strong>{formatCurrency(certificate.creditBalance)}</strong>{" "}
              wartości udziału w aktualnej rundzie MapGame — wystarczy
              zagrać tym samym adresem email.
            </p>
          )}

          <p className="certificate-thanks">
            Dziękujemy, że dzięki Tobie zwierzaki mają cieplejszy dach nad
            głową ⋆˚🐾˖°
          </p>
        </div>
      </div>

      <div className="certificate-actions">
        <button
          className="button is-primary"
          onClick={() => window.print()}
        >
          Zapisz / wydrukuj
        </button>
        <Link to="/wesprzyj" className="button is-info">
          Wesprzyj jeszcze raz
        </Link>
      </div>
    </section>
  );
};
